import React from 'react';
import update from 'react-addons-update';

var SMOReservationManagerMixin = {
  
  reservationDidConfirm: function(reservation, rowIndex, xhr) {
    var replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  },
  
  reservationDidReject: function(reservation, rowIndex, xhr) {
    var replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  },
  
  reservationDidCancel: function(reservation, rowIndex, xhr) {
    var replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  },
  
  reservationDidRefund: function(reservation, rowIndex, xhr) {
    var replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  },

  unapprovedReservationDidConfirm: function(reservation, rowIndex, xhr) {
    var replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  },

  unapprovedReservationDidFailToConfirm: function(reservation, rowIndex, xhr) {
    var replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  },

  unapprovedReservationDidReject: function(reservation, rowIndex, xhr) {
    var replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  },

  unapprovedReservationDidFailToReject: function(reservation, rowIndex, xhr) {
    var replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  },

};
export default SMOReservationManagerMixin;


// WEBPACK FOOTER //
// ./app/javascript/components/mixins/SMOReservationManagerMixin.js